export const TOOL_TASK = 'update-device-registration';
export const TOOL_TITLE = 'Update Device Registration';
export const TOOL_STACK_OVERFLOW_MESSAGE = 'Please try again once updating the users\' device registration finishes';
export const FILE_NAME = 'Update-device-registration-report';
export const FILE_HEADERS = {
    userId: 'User Id',
    email: 'Email',
    oldEnabledStatus: 'Old Status',
    newEnabledStatus: 'New Status',
    actionStatus: 'Action Status',
};

export const TOOL_PROGRESS_LABEL = 'Bulk device registration updating progress...';

export const DEVICE_REGISTRATION_MODAL_TITLES = {
    ENABLE_DEVICE_REGISTRATION: 'Enable Device Registration',
    DISABLE_DEVICE_REGISTRATION: 'Disable Device Registration',
};

